
export enum VIPCertificateConstraint {
	none = 0,
	car = 1,
	pedestrian = 2,
	network = 4,
	cramped = 8
}

export function VIPCertificateConstraintToArray(value: VIPCertificateConstraint): VIPCertificateConstraint[] {
	return Object.keys(VIPCertificateConstraint).map(Number).filter(Boolean).reduce((list, v: VIPCertificateConstraint) => {
		if ((value & v) === v) {
			list.push(v);
		}
		return list;
	}, <VIPCertificateConstraint[]>[]);
}

export function VIPCertificateConstraintFromArray(value: VIPCertificateConstraint[]): VIPCertificateConstraint {
	return value.reduce((flag, v) => {
		return flag | v;
	}, VIPCertificateConstraint.none);
}
